export function parseFieldNumber(value: string | null): number | null {
  if (value == null || value.trim() === '') {
    return null;
  }

  const parsed = Number(value);

  return Number.isFinite(parsed) ? parsed : null;
}

export function parseBooleanField(value: string | null): boolean | null {
  if (value == null || value.trim() === '') {
    return null;
  }

  if (value === 'true' || value === '1') {
    return true;
  }

  if (value === 'false' || value === '0') {
    return false;
  }

  return null;
}

export function parseBooleanFieldValue(value: string | null): boolean {
  return value === 'true' || value === '1';
}
